module.exports = __webpack_public_path__ + "assets/img/deco-2.3da89b6f.png";